import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const SearchFieldContainerOffice = styled.div`
  display: flex;
  flex-direction: column;
  transition: ease-in-out .2s;`;

export const SearchFieldLabelOffice = styled.label`
  color: ${colors.textPrimary};
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  opacity: 0.9;
  margin-bottom: 12px;
  display: block;
`;

export const SearchFieldContentOffice = styled.div`
  width: 100%;
  position: relative;
`;

export const SearchFieldFieldOffice = styled.input`
  width: 551px;
  position: relative;
  height: 45px;
  font-size: 16px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
  padding: 12px 10px;
  border: 1px solid ${colors.darkblue};
  border-radius: 8px;
  font-size: 14px;
  color: ${colors.textPrimary};
  line-height: 18px;
  letter-spacing: 0.03em;

  &.error {
    border-bottom: solid 5px ${colors.bgDanger} !important; 
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.darkblue};
    font-size: 14px;
    opacity: 0.9;
    font-family: 'Montserrat', sans-serif;;
  }

  :-ms-input-placeholder {
    color: ${colors.textSecondary};
    font-size: 14px;
    opacity: 0.9;
    font-family: 'Montserrat', sans-serif;;
  }
`;

export const SearchFieldDataOffice = styled.div`
  width: 100%;
  border-radius: 8px;
  top: 55px;
  left: 0;
  position: absolute;
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  max-height: 210px;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  max-height: 210px !important;
  overflow: ${prop => prop.open ? '' : 'hidden'};
  overflow-y: scroll;
  z-index: 99;
`;

export const SearchFieldSelectOptionOffice = styled.div`
padding: 10px;
background: ${prop => prop.active ? colors.bgFilterSelected : colors.white};
transition: ease-in-out .2s;
z-index: 999;

&:hover {
  background: ${colors.bgSuccess};
}

&:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

&:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
`;

export const SearchFieldErrorMessageOffice = styled.small`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 8px;
  opacity: ${prop => prop.error ? '1' : '0'};
`;
